import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import '../../../assests/css/customer/UserProfile.css';
import MyNavbar from '../../../components/Customer/Mynavbar/MyNavbar';
import UserMasterLayout from '../../../Layouts/UserMasterLayout/UserMasterLayout';
import AppContext from '../../../context/AppContext';

const UserProfile = () => {
  const { baseUrl, authToken, customer, setCustomer } = useContext(AppContext);

  const [showEditModal, setShowEditModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  const [editFormData, setEditFormData] = useState({
    firstname: '', lastname: '', email: '',
  });

  const [passwordData, setPasswordData] = useState({
    old_password: '', new_password: '', confirmPassword: ''
  });

  const [passwordValidation, setPasswordValidation] = useState({
    minLength: false, hasUppercase: false, hasSpecialChar: false
  });

  // customer AppContext se aata hai (login/signup ke foran baad khud fetch ho chuka hota hai) —
  // alag se dobara /profile call karne ki zaroorat nahi
  const userData = customer;
  const loading  = !!authToken && !customer; // token hai lekin customer abhi tak load nahi hua

  // editFormData ko userData available hote hi sync karo
  useEffect(() => {
    if (customer) {
      setEditFormData(customer);
    }
  }, [customer]);


//  const handleSaveDetails = () => {
//     axios.post(`${baseUrl}/customer/updateprofile`, editFormData, authHeaders)
//     .then(() => {
    
//     axios.get(`${baseUrl}/profile`, authHeaders)
//       .then(res => setUserData(res.data.customer))
//       .catch((err) => console.log(err)); 
//     setShowEditModal(false);
//     Swal.fire('Success', 'Profile update ho gayi!', 'success');
// })

  // ─── Save Details ─────────────────────────────────────────────
  const handleSaveDetails = () => {
    const authHeaders = { headers: { Authorization: `Bearer ${authToken}` } };

    axios.post(`${baseUrl}/customer/updateprofile`, editFormData, authHeaders)
      .then(() => {
        setShowEditModal(false);
        Swal.fire('Success', 'Profile update ho gayi!', 'success');
        // AppContext ke customer ko bhi refresh kar do taake sari app mein naya naam turant dikhe
        axios.get(`${baseUrl}/profile`, authHeaders)
          .then(res => {
            // agar AppContext mein setCustomer available hai to yahan use karo:
            setCustomer(res.data.customer);
          });
      })
      .catch((err) => {
        const msg = err.response?.data?.message || 'Update nahi ho saka';
        Swal.fire('Error', msg, 'error');
      });
  };

  // ─── Update Password ─────────────────────────────────────────
  const handleSavePassword = () => {
    const authHeaders = { headers: { Authorization: `Bearer ${authToken}` } };

    if (passwordData.new_password !== passwordData.confirmPassword) {
      Swal.fire('Error', 'Passwords match nahi kar rahe', 'error');
      return;
    }

    axios.post(`${baseUrl}/customer/updateprofile`, {
      old_password: passwordData.old_password,
      new_password: passwordData.new_password,
    }, authHeaders)
      .then(() => {
        setShowPasswordModal(false);
        setPasswordData({ old_password: '', new_password: '', confirmPassword: '' });
        Swal.fire('Success', 'Password change ho gaya!', 'success');
      })
      .catch((err) => {
        const msg = err.response?.data?.message || 'Error aaya';
        Swal.fire('Error', msg, 'error');
      });
  };

  // ─── onChange Handlers ────────────────────────────────────────
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData(prev => ({ ...prev, [name]: value }));
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData(prev => ({ ...prev, [name]: value }));
    if (name === 'new_password') {
      setPasswordValidation({
        minLength: value.length >= 8,
        hasUppercase: /[A-Z]/.test(value),
        hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(value)
      });
    }
  };

  if (loading) return (
    <UserMasterLayout>
      <div style={{ textAlign: 'center', padding: '50px' }}>Loading...</div>
    </UserMasterLayout>
  );

  return (
    <UserMasterLayout>
      <div className="up-profile-container">

        <div className="up-profile-page-header">
          <h1 className="up-profile-main-title">Personal Details</h1>
          <p className="up-profile-page-subtitle">View and manage your personal information.</p>
        </div>

        {/* ── Your Details Card ── */}
        <div className="up-profile-details-card">
          <div className="up-profile-card-header">
            <h2 className="up-profile-card-title">Your Details</h2>
            <button className="up-profile-edit-btn" onClick={() => setShowEditModal(true)}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
              </svg>
              Edit Details
            </button>
          </div>

          <div className="up-profile-info-grid">
            {[
              { label: 'First Name', value: userData?.firstname },
              { label: 'Last Name', value: userData?.lastname },
              { label: 'Email Address', value: userData?.email },
            ].map(({ label, value }) => (
              <div className="up-profile-info-item" key={label}>
                <label className="up-profile-info-label">{label}</label>
                <p className="up-profile-info-value">{value || '---'}</p>
              </div>
            ))}
          </div>
        </div>

        {/* ── Security Card ── */}
        <div className="up-profile-details-card">
          <div className="up-profile-card-header">
            <h2 className="up-profile-card-title">Security</h2>
            <button className="up-profile-edit-btn" onClick={() => setShowPasswordModal(true)}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
              Change Password
            </button>
          </div>
          <div className="up-profile-security-info">
            <div className="up-profile-security-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              </svg>
            </div>
            <div className="up-profile-security-text">
              <h3>Password Protection</h3>
              <p>Keep your account secure by updating your password regularly.</p>
            </div>
          </div>
        </div>

        {/* ── Edit Modal ── */}
        {showEditModal && (
          <div className="up-profile-modal-overlay" onClick={() => setShowEditModal(false)}>
            <div className="up-profile-modal" onClick={e => e.stopPropagation()}>
              <div className="up-profile-modal-header">
                <h3 className="up-profile-modal-title">Edit Personal Details</h3>
                <button className="up-profile-modal-close" onClick={() => setShowEditModal(false)}>✕</button>
              </div>

              <div className="up-profile-modal-body">
                <div className="up-profile-modal-form-row">
                  <div className="up-profile-modal-form-group">
                    <label className="up-profile-modal-label">First Name</label>
                    <input className="up-profile-modal-input" type="text" name="firstname"
                      value={editFormData.firstname} onChange={handleEditChange} placeholder="First name" />
                  </div>
                  <div className="up-profile-modal-form-group">
                    <label className="up-profile-modal-label">Last Name</label>
                    <input className="up-profile-modal-input" type="text" name="lastname"
                      value={editFormData.lastname} onChange={handleEditChange} placeholder="Last name" />
                  </div>
                </div>

                <div className="up-profile-modal-form-row">
                  <div className="up-profile-modal-form-group">
                    <label className="up-profile-modal-label">Email</label>
                    <input className="up-profile-modal-input" type="email" name="email"
                      value={editFormData.email} onChange={handleEditChange} placeholder="Email" />
                  </div>
                </div>
              </div>

              <div className="up-profile-modal-footer">
                <button className="up-profile-modal-cancel-btn" onClick={() => setShowEditModal(false)}>Cancel</button>
                <button className="up-profile-modal-save-btn" onClick={handleSaveDetails}>Save Changes</button>
              </div>
            </div>
          </div>
        )}

        {/* ── Password Modal ── */}
        {showPasswordModal && (
          <div className="up-profile-modal-overlay" onClick={() => setShowPasswordModal(false)}>
            <div className="up-profile-modal" onClick={e => e.stopPropagation()}>
              <div className="up-profile-modal-header">
                <h3 className="up-profile-modal-title">Change Password</h3>
                <button className="up-profile-modal-close" onClick={() => setShowPasswordModal(false)}>✕</button>
              </div>

              <div className="up-profile-modal-body">
                {[
                  { label: 'Current Password', name: 'old_password' },
                  { label: 'New Password', name: 'new_password' },
                  { label: 'Confirm Password', name: 'confirmPassword' }
                ].map(({ label, name }) => (
                  <div className="up-profile-modal-form-group" key={name}>
                    <label className="up-profile-modal-label">{label}</label>
                    <input className="up-profile-modal-input" type="password"
                      name={name} value={passwordData[name]} onChange={handlePasswordChange}
                      placeholder={label} />
                  </div>
                ))}

                <div className="up-profile-password-requirements">
                  <p className="up-profile-requirements-title">Password must contain:</p>
                  {[
                    { key: 'minLength', text: 'At least 8 characters' },
                    { key: 'hasUppercase', text: 'An uppercase letter' },
                    { key: 'hasSpecialChar', text: 'A special character (!@#$%^&*)' }
                  ].map(({ key, text }) => (
                    <div key={key} className={`up-profile-requirement ${passwordValidation[key] ? 'up-profile-valid' : 'up-profile-invalid'}`}>
                      <span className="up-profile-requirement-icon">{passwordValidation[key] ? '✓' : '✗'}</span>
                      <span>{text}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="up-profile-modal-footer">
                <button className="up-profile-modal-cancel-btn" onClick={() => setShowPasswordModal(false)}>Cancel</button>
                <button className="up-profile-modal-save-btn" onClick={handleSavePassword}>Update Password</button>
              </div>
            </div>
          </div>
        )}

      </div>
    </UserMasterLayout>
  );
};

export default UserProfile;